import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i2 from 'base-beneficiary-personal-details-library';
import { BaseBeneficiaryPersonalDetailsLibraryService } from 'base-beneficiary-personal-details-library';
import { first } from 'rxjs/operators';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'task-notes-lib';
import { TaskNotesLibModule } from 'task-notes-lib';
import * as i5 from 'step-status-update-payload-service';
import * as i6 from '@angular/router';
import * as i7 from 'dirty-check-store';
import * as i8 from '@angular/common';
import * as i9 from 'generic-beneficiary-personal-details-library';
import { GenericBeneficiaryPersonalDetailsLibraryModule } from 'generic-beneficiary-personal-details-library';
import * as i10 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i11 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i12 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i13 from 'primeng/divider';
import * as i14 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i15 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';
import { DateFormatModule } from 'date-format';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { AvatarModule } from 'ngx-avatar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

class BeneficiaryPersonalDetailsLibraryService {
    constructor() { }
}
BeneficiaryPersonalDetailsLibraryService.ɵfac = function BeneficiaryPersonalDetailsLibraryService_Factory(t) { return new (t || BeneficiaryPersonalDetailsLibraryService)(); };
BeneficiaryPersonalDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BeneficiaryPersonalDetailsLibraryService, factory: BeneficiaryPersonalDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeneficiaryPersonalDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { "layoutCode": a0 }; };
function BeneficiaryPersonalDetailsLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵelementStart(3, "h5", 16);
    i0.ɵɵtext(4, "Beneficiary Personal Information");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵelementStart(6, "ul");
    i0.ɵɵelementStart(7, "li", 18);
    i0.ɵɵelement(8, "lib-step-status-update-component-library", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "li", 20);
    i0.ɵɵelement(10, "lib-maximize-dialog-library", 21);
    i0.ɵɵelementStart(11, "i", 22);
    i0.ɵɵlistener("click", function BeneficiaryPersonalDetailsLibraryComponent_div_1_Template_i_click_11_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("visaType", ctx_r0.inputData.caseType != "I130" ? ctx_r0.inputData.visatype : ctx_r0.inputData.caseType)("stepDetails", ctx_r0.stepDetails)("isViewMode", ctx_r0.inputData["isViewMode"])("isCaseRequest", ctx_r0.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(5, _c0, ctx_r0.inputData == null ? null : ctx_r0.inputData.layoutCode));
} }
function BeneficiaryPersonalDetailsLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "lib-assigning-task-library", 25);
    i0.ɵɵlistener("updateStatus", function BeneficiaryPersonalDetailsLibraryComponent_div_2_Template_lib_assigning_task_library_updateStatus_2_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r1.inputData.visatype)("stepDetails", ctx_r1.stepDetails)("isViewMode", ctx_r1.inputData["isViewMode"])("isCaseRequest", ctx_r1.inputData["isCaseRequest"]);
} }
function BeneficiaryPersonalDetailsLibraryComponent_p_divider_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 26);
} }
function BeneficiaryPersonalDetailsLibraryComponent_lib_last_update_library_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-last-update-library", 27);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputDetails", ctx_r3.stepDetails)("primaryData", ctx_r3.inputData);
} }
function BeneficiaryPersonalDetailsLibraryComponent_p_divider_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function BeneficiaryPersonalDetailsLibraryComponent_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "button", 31);
    i0.ɵɵlistener("click", function BeneficiaryPersonalDetailsLibraryComponent_div_13_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.handleEditClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r12.disabledControls);
} }
function BeneficiaryPersonalDetailsLibraryComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, BeneficiaryPersonalDetailsLibraryComponent_div_13_div_1_Template, 2, 1, "div", 29);
    i0.ɵɵelement(2, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isEditMode);
} }
function BeneficiaryPersonalDetailsLibraryComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "div", 30);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵelement(3, "lib-step-status-update-component-library", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("visaType", ctx_r6.inputData.caseType != "I130" ? ctx_r6.inputData.visatype : ctx_r6.inputData.caseType)("stepDetails", ctx_r6.stepDetails)("type", ctx_r6.typeOfButton)("isViewMode", ctx_r6.inputData["isViewMode"])("isCaseRequest", ctx_r6.inputData["isCaseRequest"])("showPreviousStepBtn", ctx_r6.showPrev)("showNextStepBtn", ctx_r6.showNext);
} }
function BeneficiaryPersonalDetailsLibraryComponent_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "button", 31);
    i0.ɵɵlistener("click", function BeneficiaryPersonalDetailsLibraryComponent_div_15_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.handleEditClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r15.disabledControls);
} }
function BeneficiaryPersonalDetailsLibraryComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, BeneficiaryPersonalDetailsLibraryComponent_div_15_div_1_Template, 2, 1, "div", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.isEditMode);
} }
class BeneficiaryPersonalDetailsLibraryComponent extends BaseBeneficiaryPersonalDetailsLibraryService {
    constructor(store, apiService, toastr, taskNotesService, stepStatusUpdatePayloadCostructionService, routerr, guard) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, routerr);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.taskNotesService = taskNotesService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.routerr = routerr;
        this.guard = guard;
        this.onDialogClose = new EventEmitter();
        this.isEditMode = false;
        this.caption = '';
        this.showUploadPassport = true;
        this.personalDetailsEdit = false;
        this.profileEducationUpdate = true;
        this.profileUpdate = true;
        this.editClicked = false;
        this.showNext = false;
        this.showPrev = false;
    }
    ngOnInit() {
        var _a, _b;
        //this.caption = this.routerr.getCurrentNavigation().extras.state ?
        //this.routerr.getCurrentNavigation().extras.state.profileName : this.caption;
        this.isSimplifyH1b = this.simplifyH1b;
        this.inputData = this.primaryData;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.showNext = (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.showPrev;
        localStorage.setItem("currentUserSelection", JSON.stringify(this.selectedDetailAbout));
        this.selectedDetailAbout = {
            showDetailFor: 'self',
        };
        this.personalDetailsEdit = (this.beneficiaryProfileUpdate == 'true');
        this.getBeneDetailsLibrary();
        super.loadInit();
    }
    personalDetails(param) {
        this.getBeneDetailsLibrary();
    }
    getBeneDetailsLibrary() {
        if (this.beneficiaryProfileUpdate === 'true' || (sessionStorage.getItem('listBeneficiaryId') && sessionStorage.getItem('relativeId'))) { //beneficiaryId
            this.profileEducationUpdate = false;
            this.profileUpdate = true;
        }
        else {
            this.profileEducationUpdate = true;
            this.profileUpdate = false;
        }
    }
    onEditClicked(status) {
        this.editClicked = status;
    }
    editDetails() {
        this.isEditMode = true;
    }
    onHasPassportChange(flag) {
        this.showUploadPassport = flag;
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.onDestroy();
    }
    updateNoteAvailability(e) {
        this.stepDetails['notesAvailable'] = (e === null || e === void 0 ? void 0 : e.notesAvailable) || false;
        this.stepDetails.notes.noteText = (e === null || e === void 0 ? void 0 : e.noteText) || '';
    }
    onClosePersonalEdit() {
        this.isEditMode = false;
        super.getBenDataProfile();
    }
    handleEditClose() {
        this.isEditMode = false;
        super.getBenDataProfile();
    }
}
BeneficiaryPersonalDetailsLibraryComponent.ɵfac = function BeneficiaryPersonalDetailsLibraryComponent_Factory(t) { return new (t || BeneficiaryPersonalDetailsLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIBeneficiaryPersonalDetails), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.TaskNotesService), i0.ɵɵdirectiveInject(i5.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i6.Router), i0.ɵɵdirectiveInject(i7.DirtyFormGuard)); };
BeneficiaryPersonalDetailsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: BeneficiaryPersonalDetailsLibraryComponent, selectors: [["beneficiary-personal-details-library"]], inputs: { primaryData: "primaryData", simplifyH1b: "simplifyH1b" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 16, vars: 15, consts: [[1, "fluid-container"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "header-divider", 4, "ngIf"], [1, "main-body", "footer-adjust-v2"], ["sectionCode", "PERSONAL_DETAIL", 3, "inputDetails", "primaryData", 4, "ngIf"], [1, "row", "pt-4"], [1, "col-md-10", "form-group"], [1, "sub-title", "common-bene-class-for-translation"], [1, "clearfix"], [3, "detailsAbout", "editMode", "isShowVerify", "passportShow", "isShowProfilePic", "isEditDisabled", "primaryData", "personalDetails", "profileEditStatus", "hasPassportChange"], [4, "ngIf"], ["class", "row pt-3", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title"], [1, "w-100", "d-flex"], [1, "mb-0", "common-bene-class-for-translation"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", 3, "click"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "header-divider"], ["sectionCode", "PERSONAL_DETAIL", 3, "inputDetails", "primaryData"], [1, "row", "pt-3"], ["class", "col-md-6", 4, "ngIf"], [1, "col-md-6"], ["pButton", "", "type", "button", "label", "Close", 1, "save-btn", "common-bene-class-for-translation", 3, "disabled", "click"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "isViewMode", "isCaseRequest", "showPreviousStepBtn", "showNextStepBtn"], ["class", "col-md-12 customSave alignRight", 4, "ngIf"], [1, "col-md-12", "customSave", "alignRight"]], template: function BeneficiaryPersonalDetailsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, BeneficiaryPersonalDetailsLibraryComponent_div_1_Template, 12, 7, "div", 1);
        i0.ɵɵtemplate(2, BeneficiaryPersonalDetailsLibraryComponent_div_2_Template, 3, 4, "div", 2);
        i0.ɵɵtemplate(3, BeneficiaryPersonalDetailsLibraryComponent_p_divider_3_Template, 1, 0, "p-divider", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, BeneficiaryPersonalDetailsLibraryComponent_lib_last_update_library_5_Template, 1, 2, "lib-last-update-library", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelementStart(8, "h5", 8);
        i0.ɵɵtext(9, "Personal Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(10, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "lib-generic-beneficiary-personal-details-library", 10);
        i0.ɵɵlistener("personalDetails", function BeneficiaryPersonalDetailsLibraryComponent_Template_lib_generic_beneficiary_personal_details_library_personalDetails_11_listener($event) { return ctx.personalDetails($event); })("profileEditStatus", function BeneficiaryPersonalDetailsLibraryComponent_Template_lib_generic_beneficiary_personal_details_library_profileEditStatus_11_listener($event) { return ctx.onEditClicked($event); })("hasPassportChange", function BeneficiaryPersonalDetailsLibraryComponent_Template_lib_generic_beneficiary_personal_details_library_hasPassportChange_11_listener($event) { return ctx.onHasPassportChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, BeneficiaryPersonalDetailsLibraryComponent_p_divider_12_Template, 1, 0, "p-divider", 11);
        i0.ɵɵtemplate(13, BeneficiaryPersonalDetailsLibraryComponent_div_13_Template, 3, 1, "div", 12);
        i0.ɵɵtemplate(14, BeneficiaryPersonalDetailsLibraryComponent_div_14_Template, 4, 7, "div", 12);
        i0.ɵɵtemplate(15, BeneficiaryPersonalDetailsLibraryComponent_div_15_Template, 2, 1, "div", 12);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("detailsAbout", ctx.selectedDetailAbout)("editMode", ctx.personalDetailsEdit)("isShowVerify", true)("passportShow", true)("isShowProfilePic", false)("isEditDisabled", ctx.disabledControls)("primaryData", ctx.inputData);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? true : false);
    } }, directives: [i8.NgIf, i9.GenericBeneficiaryPersonalDetailsLibraryComponent, i10.StepStatusUpdateComponentLibraryComponent, i11.MaximizeDialogLibraryComponent, i12.AssigningTaskLibraryComponent, i13.Divider, i14.LastUpdateLibraryComponent, i15.ButtonDirective], styles: [".label-cls[_ngcontent-%COMP%]{font:normal normal 300 14px/20px Source Sans Pro;color:#4a4a4a}.readOnly-label[_ngcontent-%COMP%]{width:100%;font:normal normal normal 16px/22px Source Sans Pro;color:#4a4a4a}.requiredFields[_ngcontent-%COMP%]{color:red}.sub-title[_ngcontent-%COMP%]{font:normal normal 600 20px/20px Source Sans Pro;color:#4a4a4a}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:10px 30px!important;font-size:14px!important;border-radius:8px!important}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.main-body[_ngcontent-%COMP%]{overflow-x:hidden;overflow-x-font:normal normal bold 22px/32px Source Sans Pro;overflow-x-color:#3d3d63}.main-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;color:#626262}.save-btn[_ngcontent-%COMP%]{font:normal normal 700 14px/20px Source Sans Pro!important;color:#fff!important;text-transform:uppercase!important}.icon-background[_ngcontent-%COMP%]{height:30px;display:inline-block;border-radius:50%;width:30px;padding:4px;vertical-align:middle;background:#ededed;margin:0 10px;position:relative!important;right:0}.icon-background.notes[_ngcontent-%COMP%]{height:34px!important;margin:0 4px!important;cursor:pointer;border-radius:0}.icon-background.notes[_ngcontent-%COMP%]   .icn-note[_ngcontent-%COMP%]{background-repeat:no-repeat;position:absolute;height:22px;width:18px}.icon-background.notes.yellow[_ngcontent-%COMP%]{background:#febc54}.notepanel   [_nghost-%COMP%]     .p-overlaypanel{width:500px!important;background:#fff3df!important;top:auto!important;right:-20px}.notepanel   [_nghost-%COMP%]     .p-overlaypanel:before{margin-left:6px!important;border-bottom-color:transparent!important}.notepanel   [_nghost-%COMP%]     .p-overlaypanel:after{border:0!important;border-color:transparent!important}.notepanel   [_nghost-%COMP%]     .p-overlaypanel .p-overlaypanel-close{background:#febc54!important;color:#777!important}.updateProfile[_ngcontent-%COMP%]{position:absolute;display:flex;padding-left:338px;padding-bottom:21px}.editDetailsDiv[_ngcontent-%COMP%]     .p-dropdown{font-family:inherit;width:100%}.customEdit[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.customSave[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.mat-button-toggle-group[_ngcontent-%COMP%]{padding:4px;background-color:#eee;color:#475f7d;font-size:16px}.mat-button-toggle[_ngcontent-%COMP%]{background-color:transparent;color:#475f7d;font-size:14px;font-weight:300}.mat-button-toggle-checked[_ngcontent-%COMP%]{background-color:#fff!important}.mat-button-toggle-label-content[_ngcontent-%COMP%]{line-height:34px!important}.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle-label-content[_ngcontent-%COMP%]{padding:0 10px;line-height:35px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeneficiaryPersonalDetailsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'beneficiary-personal-details-library',
                templateUrl: './beneficiary-personal-details-library.component.html',
                styleUrls: ['./beneficiary-personal-details-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIBeneficiaryPersonalDetails }, { type: i3.ToastrService }, { type: i4.TaskNotesService }, { type: i5.StepStatusUpdatePayloadService }, { type: i6.Router }, { type: i7.DirtyFormGuard }]; }, { primaryData: [{
            type: Input
        }], simplifyH1b: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class BeneficiaryPersonalDetailsLibraryModule {
}
BeneficiaryPersonalDetailsLibraryModule.ɵfac = function BeneficiaryPersonalDetailsLibraryModule_Factory(t) { return new (t || BeneficiaryPersonalDetailsLibraryModule)(); };
BeneficiaryPersonalDetailsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: BeneficiaryPersonalDetailsLibraryModule });
BeneficiaryPersonalDetailsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseBeneficiaryPersonalDetailsLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            // EditPersonalDetailsModule,
            DateFormatModule,
            LastUpdateLibraryModule,
            TaskNotesLibModule,
            AssigningTaskLibraryModule,
            CustomQuestionnaireModule,
            MaximizeDialogLibraryModule,
            MatListModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            MatCardModule,
            MatCheckboxModule,
            MatDatepickerModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatRadioModule,
            MatSelectModule,
            AvatarModule,
            MatIconModule,
            // SimplePersonalDetailLibraryModule,
            GenericBeneficiaryPersonalDetailsLibraryModule,
            MatButtonToggleModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BeneficiaryPersonalDetailsLibraryModule, { declarations: [BeneficiaryPersonalDetailsLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        // EditPersonalDetailsModule,
        DateFormatModule,
        LastUpdateLibraryModule,
        TaskNotesLibModule,
        AssigningTaskLibraryModule,
        CustomQuestionnaireModule,
        MaximizeDialogLibraryModule,
        MatListModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSelectModule,
        AvatarModule,
        MatIconModule,
        // SimplePersonalDetailLibraryModule,
        GenericBeneficiaryPersonalDetailsLibraryModule,
        MatButtonToggleModule], exports: [BeneficiaryPersonalDetailsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeneficiaryPersonalDetailsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [BeneficiaryPersonalDetailsLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    // EditPersonalDetailsModule,
                    DateFormatModule,
                    LastUpdateLibraryModule,
                    TaskNotesLibModule,
                    AssigningTaskLibraryModule,
                    CustomQuestionnaireModule,
                    MaximizeDialogLibraryModule,
                    MatListModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatDatepickerModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatRadioModule,
                    MatSelectModule,
                    AvatarModule,
                    MatIconModule,
                    // SimplePersonalDetailLibraryModule,
                    GenericBeneficiaryPersonalDetailsLibraryModule,
                    MatButtonToggleModule,
                ],
                providers: [BaseBeneficiaryPersonalDetailsLibraryService],
                exports: [BeneficiaryPersonalDetailsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of beneficiary-personal-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BeneficiaryPersonalDetailsLibraryComponent, BeneficiaryPersonalDetailsLibraryModule, BeneficiaryPersonalDetailsLibraryService };
//# sourceMappingURL=beneficiary-personal-details-library.js.map
